// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    // Cabeçalho — colunas da grade de Cargas
    'shipments.contratoAreaUtil.colNumero': 'Nº',
    'shipments.contratoAreaUtil.codigoCarga': 'Código da carga {{code}}',
    'shipments.contratoAreaUtil.colDataHora': 'Data / Hora',
    'shipments.contratoAreaUtil.colDia': 'Dia',
    'shipments.contratoAreaUtil.colProg': 'Prog.',
    'shipments.contratoAreaUtil.progNaoEnviada': 'Programação não enviada',
    'shipments.contratoAreaUtil.progEnviada': 'Programação enviada',
    'shipments.contratoAreaUtil.progRecebida': 'Programação recebida pelo motorista',
    'shipments.contratoAreaUtil.motorista': 'Motorista',
    'shipments.contratoAreaUtil.placa': 'Placa',
    'shipments.contratoAreaUtil.carreta': 'Carreta',
    'shipments.contratoAreaUtil.viagem': 'Viagem',
    'shipments.contratoAreaUtil.colLocalAtual': 'Local atual',
    'shipments.contratoAreaUtil.semLocalAtual': 'Sem local atual',
    'shipments.contratoAreaUtil.posicaoRecebida': 'Posição recebida {{when}}',
    'shipments.contratoAreaUtil.abrirNoGoogleMaps': 'Abrir a posição de {{placa}} no Google Maps',
    'shipments.contratoAreaUtil.semPosicaoParaMaps': 'Sem coordenada transmitida',
    'shipments.contratoAreaUtil.posicaoAgora': 'agora',
    'shipments.contratoAreaUtil.posicaoHa': 'há {{value}}',
    'shipments.contratoAreaUtil.statusViagem': 'Status viagem',
    'shipments.contratoAreaUtil.vpNumber': 'Nº VP',
    'shipments.contratoAreaUtil.solicitacaoVp': 'Solicitação VP',
    'shipments.contratoAreaUtil.notaFiscal': 'Nota Fiscal',
    'shipments.contratoAreaUtil.statusNota': 'Status nota',
    'shipments.contratoAreaUtil.loteCte': 'Lote CT-e',
    'shipments.contratoAreaUtil.observacoes': 'Observações',
    // Coluna Motorista — tooltip e editor
    'shipments.contratoAreaUtil.motoristaTooltip': 'Somente motoristas disponíveis podem ser selecionados. Digite para ver os demais e o motivo.',
    'shipments.contratoAreaUtil.buscarMotorista': 'Buscar motorista…',
    'shipments.contratoAreaUtil.nenhumMotorista': 'Nenhum motorista encontrado',
    // Coluna Ações — tooltips e aria-labels
    'shipments.contratoAreaUtil.observacaoAtiva': 'Observação ativa',
    'shipments.contratoAreaUtil.adicionarObservacao': 'Adicionar observação',
    'shipments.contratoAreaUtil.observacao': 'Observação',
    'shipments.contratoAreaUtil.historicoViagem': 'Histórico da viagem',
    'shipments.contratoAreaUtil.excluirCarga': 'Excluir carga',
    // Situação do contrato
    'shipments.contratoAreaUtil.situacaoAtualizada': 'Situação atualizada.',
    'shipments.contratoAreaUtil.situacaoContrato': 'Situação do contrato',
    'shipments.contratoAreaUtil.buscarSituacao': 'Buscar situação…',
    // Tag Solicitação VP
    'shipments.contratoAreaUtil.semNumeroVp': 'Sem Nº VP — não solicitado',
    'shipments.contratoAreaUtil.ultimaAtualizacao': 'Última atualização: {{date}}',
    'shipments.contratoAreaUtil.aguardandoSync': 'Aguardando primeira sincronização com o Protheus',
    // Estado vazio
    'shipments.contratoAreaUtil.selecioneContrato': 'Selecione um contrato para ver a frente de trabalho.',
    // Contadores da seção Cargas
    'shipments.contratoAreaUtil.total': 'Total',
    'shipments.contratoAreaUtil.feitas': 'Feitas',
    'shipments.contratoAreaUtil.emAndamento': 'Em andamento',
    'shipments.contratoAreaUtil.pendentes': 'Pendentes',
    'shipments.contratoAreaUtil.canceladas': 'Canceladas',
    'shipments.contratoAreaUtil.naoAtendidas': 'Não atendidas',
    // Cabeçalho do contrato — ação e métricas
    'shipments.contratoAreaUtil.editarContrato': 'Editar contrato',
    'shipments.contratoAreaUtil.cargasFeitasPrevistas': 'Cargas feitas / previstas',
    'shipments.contratoAreaUtil.pctColheita': '% Colheita',
    'shipments.contratoAreaUtil.ocorrencias': 'Ocorrências',
    // Cabeçalho do contrato — campos
    'shipments.contratoAreaUtil.cliente': 'Cliente',
    'shipments.contratoAreaUtil.dupla': 'Dupla',
    'shipments.contratoAreaUtil.duplaPeloCliente': 'Pelo cliente',
    'shipments.contratoAreaUtil.produtor': 'Produtor',
    'shipments.contratoAreaUtil.fazenda': 'Fazenda',
    'shipments.contratoAreaUtil.municipio': 'Município',
    'shipments.contratoAreaUtil.destino': 'Destino',
    'shipments.contratoAreaUtil.buscarDestino': 'Buscar UBS de destino…',
    'shipments.contratoAreaUtil.destinoAtualizado': 'Destino da viagem atualizado. O acompanhamento passou a seguir o destino novo.',
    'shipments.contratoAreaUtil.subcontrato': 'Subcontrato',
    'shipments.contratoAreaUtil.planilha': 'Planilha de campo',
    'shipments.contratoAreaUtil.planilhaAusente': 'Frente só de transporte',
    'shipments.contratoAreaUtil.frenteProtheus': 'Frente {{num}} no ERP',
    'shipments.contratoAreaUtil.statusDoErp': 'Protheus {{num}}',
    'shipments.contratoAreaUtil.statusDoErpDica': 'Status da frente {{num}} no Protheus. Com a frente Prevista ou Em Execução, esta Frente não pode ser Finalizada',
    'shipments.contratoAreaUtil.buscarSubcontrato': 'Buscar subcontrato vigente…',
    'shipments.contratoAreaUtil.nenhumSubcontrato': 'Nenhum subcontrato vigente encontrado',
    'shipments.contratoAreaUtil.subcontratoAtualizado': 'Subcontrato da carga atualizado. Cliente e rota passam a vir dele.',
    'shipments.contratoAreaUtil.subcontratoBaixado': 'Este subcontrato foi cancelado ou encerrado no ERP depois de escolhido. A carga continua ligada a ele; o seletor não o oferece mais.',
    'shipments.contratoAreaUtil.subcontratoPendente': 'Frente ainda sem subcontrato apontado',
    'shipments.contratoAreaUtil.buscarCavalo': 'Buscar cavalo…',
    'shipments.contratoAreaUtil.buscarCarreta': 'Buscar carreta…',
    'shipments.contratoAreaUtil.cavaloObrigatorio': 'Para tirar o cavalo da carga, use Remover motorista. Deixá-la com carreta e sem quem a puxe não é um estado válido.',
    'shipments.contratoAreaUtil.composicaoTrocada': 'Composição trocada só nesta carga. O cadastro do conjunto não mudou.',
    'shipments.contratoAreaUtil.conjuntoAlterado': 'Conjunto alterado nesta carga',
    'shipments.contratoAreaUtil.conjuntoAlteradoDica': 'Motorista, cavalo ou carreta foram trocados depois da escala, e a composição desta carga não é um conjunto do cadastro. A marca some sozinha quando a linha volta a um conjunto cadastrado ou quando a gestão de frota ajusta o cadastro.',
    'shipments.contratoAreaUtil.servico': 'Serviço',
    'shipments.contratoAreaUtil.pedagio': 'Pedágio',
    'shipments.contratoAreaUtil.frente': 'Frente',
    'shipments.contratoAreaUtil.hectares': 'Hectares',
    'shipments.contratoAreaUtil.contratoJuridico': 'Contrato Jurídico',
    'shipments.contratoAreaUtil.mapas': 'Google Maps',
    'shipments.contratoAreaUtil.mapaPivo': 'Pivô',
    'shipments.contratoAreaUtil.mapaApoio': 'Ponto de Apoio',
    'shipments.contratoAreaUtil.mapaDestino': 'Destino',
    'shipments.contratoAreaUtil.mapaSemCoordenada': 'Sem coordenada cadastrada',
    'shipments.contratoAreaUtil.safra': 'Safra',
    'shipments.contratoAreaUtil.informacaoComplementar': 'Informação complementar',
    'shipments.contratoAreaUtil.valorDoErp': 'ERP',
    'shipments.contratoAreaUtil.valorDoCadastro': 'Cadastro',
    'shipments.contratoAreaUtil.cargasEscaladasSolicitadas': 'Cargas escaladas / solicitadas',
    'shipments.contratoAreaUtil.pctEscaladas': '% Escaladas',
    'shipments.contratoAreaUtil.sinoLabel': 'Anomalias da frente',
    'shipments.contratoAreaUtil.sinoAnomalias': '{{count}} anomalias entre o cadastro e o ERP. Clique para ver.',
    'shipments.contratoAreaUtil.sinoSemAnomalias': 'Cadastro e ERP conferem',
    'shipments.contratoAreaUtil.sinoTitulo': 'Cadastro e ERP divergem',
    'shipments.contratoAreaUtil.anomaliaFrente.pedagio': 'Pedágio diferente do ERP',
    'shipments.contratoAreaUtil.anomaliaFrente.km': 'KM diferente do ERP',
    'shipments.contratoAreaUtil.anomaliaFrente.hectares': 'Hectares diferentes do ERP',
    // Seção Cargas
    'shipments.contratoAreaUtil.cargas': 'Cargas',
    'shipments.contratoAreaUtil.adicionarCarga': 'Adicionar carga',
    'shipments.contratoAreaUtil.retry': 'Tentar de novo',
    'shipments.contratoAreaUtil.nenhumaCarga': 'Nenhuma carga para este contrato.',
    // Toasts
    'shipments.contratoAreaUtil.definaDataCarga': 'Defina a data da carga antes de escolher o motorista.',
    'shipments.contratoAreaUtil.observacoesObrigatorio': 'Observações é obrigatório enquanto o alerta de observação estiver ativo. Resolva o alerta para limpar.',
    'shipments.contratoAreaUtil.viagemEncerradaStatus': 'Viagem encerrada não aceita mudança de status.',
    'shipments.contratoAreaUtil.tripStatusToast': 'Status da viagem: {{status}}.',
    'shipments.contratoAreaUtil.viagemConcluidaAtendido': 'Viagem concluída como Atendido.',
    'shipments.contratoAreaUtil.viagemNaoAtendido': 'Viagem encerrada como Não atendido. O conjunto voltou para Disponível no Painel de Descarga.',
    'shipments.contratoAreaUtil.reabrirViagem': 'Reabrir viagem',
    'shipments.contratoAreaUtil.reabrirViagemTitle': 'Reabrir a viagem {{number}}',
    'shipments.contratoAreaUtil.reabrirMessage': 'A viagem está encerrada como {{status}}. Reabrir a devolve ao status em que ela estava quando foi encerrada, religa o monitoramento e fica registrado no histórico com o motivo.',
    'shipments.contratoAreaUtil.reabrirWarning': 'Descreva o motivo da reabertura.',
    'shipments.contratoAreaUtil.reabrir': 'Reabrir',
    'shipments.contratoAreaUtil.viagemReaberta': 'Viagem reaberta em {{status}}.',
    'shipments.contratoAreaUtil.semEtapa': 'sem etapa',
    'shipments.contratoAreaUtil.alertaAtivado': 'Alerta de observação ativado.',
    'shipments.contratoAreaUtil.alertaResolvido': 'Alerta de observação resolvido.',
    'shipments.contratoAreaUtil.cargaExcluida': 'Carga {{number}} excluída.',
    'shipments.contratoAreaUtil.motoristaRemovido': 'Motorista removido. Ele voltou para Disponível no Painel de Descarga.',
    // Diálogos de confirmação
    'shipments.contratoAreaUtil.excluirCargaTitle': 'Excluir carga?',
    'shipments.contratoAreaUtil.excluirCargaMessage': 'A carga {{number}} será excluída. Esta ação não pode ser desfeita.',
    'shipments.contratoAreaUtil.removerMotoristaTitle': 'Remover motorista da carga?',
    'shipments.contratoAreaUtil.unassignMessage': '{{driver}} voltará para Disponível no Painel de Descarga e poderá ser escalado em outra carga.',
    'shipments.contratoAreaUtil.theDriver': 'O motorista',
    'shipments.contratoAreaUtil.remove': 'Remover',
    'shipments.contratoAreaUtil.motoristaComprometido': 'Motorista já comprometido',
    'shipments.contratoAreaUtil.escalarMesmoAssim': 'Escalar mesmo assim',
    // Aviso ao escalar fora de Disponível
    'shipments.contratoAreaUtil.warnBase': 'O motorista {{name}} já está {{status}}',
    'shipments.contratoAreaUtil.warnFrente': 'na frente {{frente}}',
    'shipments.contratoAreaUtil.warnDia': 'no dia {{dia}}',
    'shipments.contratoAreaUtil.warnAsk': 'Deseja escalar mesmo assim?',
    'shipments.contratoAreaUtil.unavailable': 'indisponível',
    // Diálogo de justificativa (Status viagem)
    'shipments.contratoAreaUtil.concluirViagemAtendido': 'Concluir viagem como Atendido',
    'shipments.contratoAreaUtil.avancarPara': 'Avançar para {{status}}',
    'shipments.contratoAreaUtil.atendidoMessage': 'A viagem {{number}} será marcada como Atendido e o monitoramento automático será encerrado. O conjunto permanece Descarregando no Painel de Descarga até você marcá-lo como Disponível.',
    'shipments.contratoAreaUtil.atendidoWarning': 'A etapa atual não é Descarregando. Descreva a justificativa para concluir fora da ordem.',
    'shipments.contratoAreaUtil.tripWarning': 'A etapa está fora da ordem sequencial. Descreva a justificativa para avançar.',
    'shipments.contratoAreaUtil.concluir': 'Concluir',
    'shipments.contratoAreaUtil.avancar': 'Avançar',
    'shipments.contratoAreaUtil.colStatusViagemHub': 'Status viagem HUB',
    'shipments.contratoAreaUtil.colFilialViagem': 'Filial / Viagem',
    'shipments.contratoAreaUtil.colStatusVp': 'Status VP',
    'shipments.contratoAreaUtil.colStatusNf': 'Status NF',
    'shipments.contratoAreaUtil.editarConjunto': 'Motorista, placa e carreta',
    'shipments.contratoAreaUtil.semMotorista': 'Sem motorista',
    'shipments.contratoAreaUtil.outraTransportadora': 'Outra transportadora',
    'shipments.contratoAreaUtil.anomaliasLabel': 'Anomalias',
    'shipments.contratoAreaUtil.anomalias': '{{count}} anomalias na viagem. Clique para ver.',
    'shipments.contratoAreaUtil.semAnomalias': 'Sem anomalias na viagem',
    'shipments.contratoAreaUtil.anomaliasTitulo': 'Anomalias da carga {{number}}',
    'shipments.contratoAreaUtil.anomalia.conjunto_motorista': 'Motorista diferente da viagem do Protheus',
    'shipments.contratoAreaUtil.anomalia.conjunto_cavalo': 'Cavalo diferente da viagem do Protheus',
    'shipments.contratoAreaUtil.anomalia.conjunto_carreta': 'Carreta diferente da viagem do Protheus',
    'shipments.contratoAreaUtil.anomaliaHub': 'No HUB',
    'shipments.contratoAreaUtil.anomaliaErp': 'No Protheus',
    'shipments.contratoAreaUtil.vincularFrenteErp': 'Vincular frente do ERP',
    'shipments.contratoAreaUtil.equipararViagens': 'Equiparar viagens',
    'shipments.contratoAreaUtil.equipararSemFrente': 'Vincule a frente do ERP antes de equiparar as viagens.',
  },
  en: {
    'shipments.contratoAreaUtil.colNumero': 'No.',
    'shipments.contratoAreaUtil.codigoCarga': 'Load code {{code}}',
    'shipments.contratoAreaUtil.colDataHora': 'Date / Time',
    'shipments.contratoAreaUtil.colDia': 'Day',
    'shipments.contratoAreaUtil.colProg': 'Sched.',
    'shipments.contratoAreaUtil.progNaoEnviada': 'Schedule not sent',
    'shipments.contratoAreaUtil.progEnviada': 'Schedule sent',
    'shipments.contratoAreaUtil.progRecebida': 'Schedule confirmed by the driver',
    'shipments.contratoAreaUtil.motorista': 'Driver',
    'shipments.contratoAreaUtil.placa': 'License plate',
    'shipments.contratoAreaUtil.carreta': 'Trailer',
    'shipments.contratoAreaUtil.viagem': 'Trip',
    'shipments.contratoAreaUtil.colLocalAtual': 'Current location',
    'shipments.contratoAreaUtil.semLocalAtual': 'No current location',
    'shipments.contratoAreaUtil.posicaoRecebida': 'Position received {{when}}',
    'shipments.contratoAreaUtil.abrirNoGoogleMaps': 'Open the position of {{placa}} in Google Maps',
    'shipments.contratoAreaUtil.semPosicaoParaMaps': 'No position transmitted',
    'shipments.contratoAreaUtil.posicaoAgora': 'just now',
    'shipments.contratoAreaUtil.posicaoHa': '{{value}} ago',
    'shipments.contratoAreaUtil.statusViagem': 'Trip status',
    'shipments.contratoAreaUtil.vpNumber': 'VP No.',
    'shipments.contratoAreaUtil.solicitacaoVp': 'VP Request',
    'shipments.contratoAreaUtil.notaFiscal': 'Invoice',
    'shipments.contratoAreaUtil.statusNota': 'Invoice status',
    'shipments.contratoAreaUtil.loteCte': 'CT-e batch',
    'shipments.contratoAreaUtil.observacoes': 'Notes',
    'shipments.contratoAreaUtil.motoristaTooltip': 'Only available drivers can be selected. Type to see the others and the reason.',
    'shipments.contratoAreaUtil.buscarMotorista': 'Search driver…',
    'shipments.contratoAreaUtil.nenhumMotorista': 'No driver found',
    'shipments.contratoAreaUtil.observacaoAtiva': 'Active note',
    'shipments.contratoAreaUtil.adicionarObservacao': 'Add note',
    'shipments.contratoAreaUtil.observacao': 'Note',
    'shipments.contratoAreaUtil.historicoViagem': 'Trip history',
    'shipments.contratoAreaUtil.excluirCarga': 'Delete load',
    'shipments.contratoAreaUtil.situacaoAtualizada': 'Situation updated.',
    'shipments.contratoAreaUtil.situacaoContrato': 'Contract situation',
    'shipments.contratoAreaUtil.buscarSituacao': 'Search situation…',
    'shipments.contratoAreaUtil.semNumeroVp': 'No VP number — not requested',
    'shipments.contratoAreaUtil.ultimaAtualizacao': 'Last update: {{date}}',
    'shipments.contratoAreaUtil.aguardandoSync': 'Awaiting first sync with Protheus',
    'shipments.contratoAreaUtil.selecioneContrato': 'Select a contract to see the work front.',
    'shipments.contratoAreaUtil.total': 'Total',
    'shipments.contratoAreaUtil.feitas': 'Done',
    'shipments.contratoAreaUtil.emAndamento': 'In progress',
    'shipments.contratoAreaUtil.pendentes': 'Pending',
    'shipments.contratoAreaUtil.canceladas': 'Cancelled',
    'shipments.contratoAreaUtil.naoAtendidas': 'Not served',
    'shipments.contratoAreaUtil.editarContrato': 'Edit contract',
    'shipments.contratoAreaUtil.cargasFeitasPrevistas': 'Loads done / expected',
    'shipments.contratoAreaUtil.pctColheita': '% Harvest',
    'shipments.contratoAreaUtil.ocorrencias': 'Incidents',
    'shipments.contratoAreaUtil.cliente': 'Customer',
    'shipments.contratoAreaUtil.dupla': 'Pair',
    'shipments.contratoAreaUtil.duplaPeloCliente': 'By customer',
    'shipments.contratoAreaUtil.produtor': 'Producer',
    'shipments.contratoAreaUtil.fazenda': 'Farm',
    'shipments.contratoAreaUtil.municipio': 'Municipality',
    'shipments.contratoAreaUtil.destino': 'Destination',
    'shipments.contratoAreaUtil.buscarDestino': 'Search destination unit…',
    'shipments.contratoAreaUtil.destinoAtualizado': 'Trip destination updated. Tracking now follows the new destination.',
    'shipments.contratoAreaUtil.subcontrato': 'Subcontract',
    'shipments.contratoAreaUtil.planilha': 'Field sheet',
    'shipments.contratoAreaUtil.planilhaAusente': 'Transport only',
    'shipments.contratoAreaUtil.frenteProtheus': 'Front {{num}} in the ERP',
    'shipments.contratoAreaUtil.statusDoErp': 'Protheus {{num}}',
    'shipments.contratoAreaUtil.statusDoErpDica': 'Status of front {{num}} in Protheus. While it is Planned or In Progress, this Work Front cannot be Finished',
    'shipments.contratoAreaUtil.buscarSubcontrato': 'Search active subcontract…',
    'shipments.contratoAreaUtil.nenhumSubcontrato': 'No active subcontract found',
    'shipments.contratoAreaUtil.subcontratoAtualizado': 'Load subcontract updated. Client and route now come from it.',
    'shipments.contratoAreaUtil.subcontratoBaixado': 'This subcontract was cancelled or closed in the ERP after it was picked. The load stays linked to it; the picker no longer offers it.',
    'shipments.contratoAreaUtil.subcontratoPendente': 'Work front not yet matched to a subcontract',
    'shipments.contratoAreaUtil.buscarCavalo': 'Search tractor unit…',
    'shipments.contratoAreaUtil.buscarCarreta': 'Search trailer…',
    'shipments.contratoAreaUtil.cavaloObrigatorio': 'To take the tractor unit off this load, use Remove driver. Leaving it with a trailer and nothing to pull it is not a valid state.',
    'shipments.contratoAreaUtil.composicaoTrocada': 'Composition swapped on this load only. The truck set on file did not change.',
    'shipments.contratoAreaUtil.conjuntoAlterado': 'Truck set changed on this load',
    'shipments.contratoAreaUtil.conjuntoAlteradoDica': 'Driver, truck or trailer were swapped after scheduling, and this load no longer matches a registered truck set. The mark clears itself once the line goes back to a registered set or fleet management adjusts the record.',
    'shipments.contratoAreaUtil.servico': 'Service',
    'shipments.contratoAreaUtil.pedagio': 'Toll',
    'shipments.contratoAreaUtil.frente': 'Work front',
    'shipments.contratoAreaUtil.hectares': 'Hectares',
    'shipments.contratoAreaUtil.contratoJuridico': 'Legal contract',
    'shipments.contratoAreaUtil.mapas': 'Google Maps',
    'shipments.contratoAreaUtil.mapaPivo': 'Pivot',
    'shipments.contratoAreaUtil.mapaApoio': 'Support point',
    'shipments.contratoAreaUtil.mapaDestino': 'Destination',
    'shipments.contratoAreaUtil.mapaSemCoordenada': 'No coordinates on file',
    'shipments.contratoAreaUtil.safra': 'Season',
    'shipments.contratoAreaUtil.informacaoComplementar': 'Additional information',
    'shipments.contratoAreaUtil.valorDoErp': 'ERP',
    'shipments.contratoAreaUtil.valorDoCadastro': 'Registry',
    'shipments.contratoAreaUtil.cargasEscaladasSolicitadas': 'Loads scheduled / requested',
    'shipments.contratoAreaUtil.pctEscaladas': '% Scheduled',
    'shipments.contratoAreaUtil.sinoLabel': 'Front anomalies',
    'shipments.contratoAreaUtil.sinoAnomalias': '{{count}} anomalies between the registry and the ERP. Click to see.',
    'shipments.contratoAreaUtil.sinoSemAnomalias': 'Registry and ERP match',
    'shipments.contratoAreaUtil.sinoTitulo': 'Registry and ERP differ',
    'shipments.contratoAreaUtil.anomaliaFrente.pedagio': 'Toll differs from the ERP',
    'shipments.contratoAreaUtil.anomaliaFrente.km': 'KM differs from the ERP',
    'shipments.contratoAreaUtil.anomaliaFrente.hectares': 'Hectares differ from the ERP',
    'shipments.contratoAreaUtil.cargas': 'Loads',
    'shipments.contratoAreaUtil.adicionarCarga': 'Add load',
    'shipments.contratoAreaUtil.retry': 'Try again',
    'shipments.contratoAreaUtil.nenhumaCarga': 'No loads for this contract.',
    'shipments.contratoAreaUtil.definaDataCarga': 'Set the load date before choosing the driver.',
    'shipments.contratoAreaUtil.observacoesObrigatorio': 'Notes is required while the note alert is active. Resolve the alert to clear it.',
    'shipments.contratoAreaUtil.viagemEncerradaStatus': 'A closed trip does not accept status changes.',
    'shipments.contratoAreaUtil.tripStatusToast': 'Trip status: {{status}}.',
    'shipments.contratoAreaUtil.viagemConcluidaAtendido': 'Trip completed as Attended.',
    'shipments.contratoAreaUtil.viagemNaoAtendido': 'Trip closed as Unattended. The set returned to Available in the Unloading Panel.',
    'shipments.contratoAreaUtil.reabrirViagem': 'Reopen trip',
    'shipments.contratoAreaUtil.reabrirViagemTitle': 'Reopen trip {{number}}',
    'shipments.contratoAreaUtil.reabrirMessage': 'The trip is closed as {{status}}. Reopening returns it to the status it had when it was closed, turns monitoring back on and is recorded in the history with the reason.',
    'shipments.contratoAreaUtil.reabrirWarning': 'Describe the reason for reopening.',
    'shipments.contratoAreaUtil.reabrir': 'Reopen',
    'shipments.contratoAreaUtil.viagemReaberta': 'Trip reopened at {{status}}.',
    'shipments.contratoAreaUtil.semEtapa': 'no step',
    'shipments.contratoAreaUtil.alertaAtivado': 'Note alert activated.',
    'shipments.contratoAreaUtil.alertaResolvido': 'Note alert resolved.',
    'shipments.contratoAreaUtil.cargaExcluida': 'Load {{number}} deleted.',
    'shipments.contratoAreaUtil.motoristaRemovido': 'Driver removed. They returned to Available in the Unloading Panel.',
    'shipments.contratoAreaUtil.excluirCargaTitle': 'Delete load?',
    'shipments.contratoAreaUtil.excluirCargaMessage': 'Load {{number}} will be deleted. This action cannot be undone.',
    'shipments.contratoAreaUtil.removerMotoristaTitle': 'Remove driver from load?',
    'shipments.contratoAreaUtil.unassignMessage': '{{driver}} will return to Available in the Unloading Panel and can be scheduled on another load.',
    'shipments.contratoAreaUtil.theDriver': 'The driver',
    'shipments.contratoAreaUtil.remove': 'Remove',
    'shipments.contratoAreaUtil.motoristaComprometido': 'Driver already committed',
    'shipments.contratoAreaUtil.escalarMesmoAssim': 'Schedule anyway',
    'shipments.contratoAreaUtil.warnBase': 'Driver {{name}} is already {{status}}',
    'shipments.contratoAreaUtil.warnFrente': 'on work front {{frente}}',
    'shipments.contratoAreaUtil.warnDia': 'on {{dia}}',
    'shipments.contratoAreaUtil.warnAsk': 'Schedule anyway?',
    'shipments.contratoAreaUtil.unavailable': 'unavailable',
    'shipments.contratoAreaUtil.concluirViagemAtendido': 'Complete trip as Attended',
    'shipments.contratoAreaUtil.avancarPara': 'Advance to {{status}}',
    'shipments.contratoAreaUtil.atendidoMessage': 'Trip {{number}} will be marked as Attended and automatic monitoring will end. The set stays Unloading in the Unloading Panel until you mark it as Available.',
    'shipments.contratoAreaUtil.atendidoWarning': 'The current step is not Unloading. Describe the justification to complete out of order.',
    'shipments.contratoAreaUtil.tripWarning': 'The step is out of sequential order. Describe the justification to advance.',
    'shipments.contratoAreaUtil.concluir': 'Complete',
    'shipments.contratoAreaUtil.avancar': 'Advance',
    'shipments.contratoAreaUtil.colStatusViagemHub': 'HUB trip status',
    'shipments.contratoAreaUtil.colFilialViagem': 'Branch / Trip',
    'shipments.contratoAreaUtil.colStatusVp': 'VP status',
    'shipments.contratoAreaUtil.colStatusNf': 'Invoice status',
    'shipments.contratoAreaUtil.editarConjunto': 'Driver, truck and trailer',
    'shipments.contratoAreaUtil.semMotorista': 'No driver',
    'shipments.contratoAreaUtil.outraTransportadora': 'Other carrier',
    'shipments.contratoAreaUtil.anomaliasLabel': 'Anomalies',
    'shipments.contratoAreaUtil.anomalias': '{{count}} anomalies on this trip. Click to see.',
    'shipments.contratoAreaUtil.semAnomalias': 'No anomalies on this trip',
    'shipments.contratoAreaUtil.anomaliasTitulo': 'Anomalies of load {{number}}',
    'shipments.contratoAreaUtil.anomalia.conjunto_motorista': 'Driver differs from the Protheus trip',
    'shipments.contratoAreaUtil.anomalia.conjunto_cavalo': 'Truck differs from the Protheus trip',
    'shipments.contratoAreaUtil.anomalia.conjunto_carreta': 'Trailer differs from the Protheus trip',
    'shipments.contratoAreaUtil.anomaliaHub': 'In the HUB',
    'shipments.contratoAreaUtil.anomaliaErp': 'In Protheus',
    'shipments.contratoAreaUtil.vincularFrenteErp': 'Link ERP front',
    'shipments.contratoAreaUtil.equipararViagens': 'Match trips',
    'shipments.contratoAreaUtil.equipararSemFrente': 'Link the ERP front before matching trips.',
  },
  es: {
    'shipments.contratoAreaUtil.colNumero': 'Nº',
    'shipments.contratoAreaUtil.codigoCarga': 'Código de la carga {{code}}',
    'shipments.contratoAreaUtil.colDataHora': 'Fecha / Hora',
    'shipments.contratoAreaUtil.colDia': 'Día',
    'shipments.contratoAreaUtil.colProg': 'Prog.',
    'shipments.contratoAreaUtil.progNaoEnviada': 'Programación no enviada',
    'shipments.contratoAreaUtil.progEnviada': 'Programación enviada',
    'shipments.contratoAreaUtil.progRecebida': 'Programación recibida por el conductor',
    'shipments.contratoAreaUtil.motorista': 'Conductor',
    'shipments.contratoAreaUtil.placa': 'Placa',
    'shipments.contratoAreaUtil.carreta': 'Remolque',
    'shipments.contratoAreaUtil.viagem': 'Viaje',
    'shipments.contratoAreaUtil.colLocalAtual': 'Ubicación actual',
    'shipments.contratoAreaUtil.semLocalAtual': 'Sin ubicación actual',
    'shipments.contratoAreaUtil.posicaoRecebida': 'Posición recibida {{when}}',
    'shipments.contratoAreaUtil.abrirNoGoogleMaps': 'Abrir la posición de {{placa}} en Google Maps',
    'shipments.contratoAreaUtil.semPosicaoParaMaps': 'Sin coordenada transmitida',
    'shipments.contratoAreaUtil.posicaoAgora': 'ahora',
    'shipments.contratoAreaUtil.posicaoHa': 'hace {{value}}',
    'shipments.contratoAreaUtil.statusViagem': 'Estado del viaje',
    'shipments.contratoAreaUtil.vpNumber': 'N.º VP',
    'shipments.contratoAreaUtil.solicitacaoVp': 'Solicitud VP',
    'shipments.contratoAreaUtil.notaFiscal': 'Factura',
    'shipments.contratoAreaUtil.statusNota': 'Estado de la factura',
    'shipments.contratoAreaUtil.loteCte': 'Lote CT-e',
    'shipments.contratoAreaUtil.observacoes': 'Observaciones',
    'shipments.contratoAreaUtil.motoristaTooltip': 'Solo se pueden seleccionar conductores disponibles. Escribe para ver los demás y el motivo.',
    'shipments.contratoAreaUtil.buscarMotorista': 'Buscar conductor…',
    'shipments.contratoAreaUtil.nenhumMotorista': 'Ningún conductor encontrado',
    'shipments.contratoAreaUtil.observacaoAtiva': 'Observación activa',
    'shipments.contratoAreaUtil.adicionarObservacao': 'Añadir observación',
    'shipments.contratoAreaUtil.observacao': 'Observación',
    'shipments.contratoAreaUtil.historicoViagem': 'Historial del viaje',
    'shipments.contratoAreaUtil.excluirCarga': 'Eliminar carga',
    'shipments.contratoAreaUtil.situacaoAtualizada': 'Situación actualizada.',
    'shipments.contratoAreaUtil.situacaoContrato': 'Situación del contrato',
    'shipments.contratoAreaUtil.buscarSituacao': 'Buscar situación…',
    'shipments.contratoAreaUtil.semNumeroVp': 'Sin Nº VP — no solicitado',
    'shipments.contratoAreaUtil.ultimaAtualizacao': 'Última actualización: {{date}}',
    'shipments.contratoAreaUtil.aguardandoSync': 'Esperando la primera sincronización con Protheus',
    'shipments.contratoAreaUtil.selecioneContrato': 'Seleccione un contrato para ver el frente de trabajo.',
    'shipments.contratoAreaUtil.total': 'Total',
    'shipments.contratoAreaUtil.feitas': 'Hechas',
    'shipments.contratoAreaUtil.emAndamento': 'En curso',
    'shipments.contratoAreaUtil.pendentes': 'Pendientes',
    'shipments.contratoAreaUtil.canceladas': 'Canceladas',
    'shipments.contratoAreaUtil.naoAtendidas': 'No atendidas',
    'shipments.contratoAreaUtil.editarContrato': 'Editar contrato',
    'shipments.contratoAreaUtil.cargasFeitasPrevistas': 'Cargas hechas / previstas',
    'shipments.contratoAreaUtil.pctColheita': '% Cosecha',
    'shipments.contratoAreaUtil.ocorrencias': 'Incidencias',
    'shipments.contratoAreaUtil.cliente': 'Cliente',
    'shipments.contratoAreaUtil.dupla': 'Pareja',
    'shipments.contratoAreaUtil.duplaPeloCliente': 'Por el cliente',
    'shipments.contratoAreaUtil.produtor': 'Productor',
    'shipments.contratoAreaUtil.fazenda': 'Finca',
    'shipments.contratoAreaUtil.municipio': 'Municipio',
    'shipments.contratoAreaUtil.destino': 'Destino',
    'shipments.contratoAreaUtil.buscarDestino': 'Buscar UBS de destino…',
    'shipments.contratoAreaUtil.destinoAtualizado': 'Destino del viaje actualizado. El seguimiento pasa a seguir el destino nuevo.',
    'shipments.contratoAreaUtil.subcontrato': 'Subcontrato',
    'shipments.contratoAreaUtil.planilha': 'Planilla de campo',
    'shipments.contratoAreaUtil.planilhaAusente': 'Frente solo de transporte',
    'shipments.contratoAreaUtil.frenteProtheus': 'Frente {{num}} en el ERP',
    'shipments.contratoAreaUtil.statusDoErp': 'Protheus {{num}}',
    'shipments.contratoAreaUtil.statusDoErpDica': 'Estado del frente {{num}} en Protheus. Con el frente Previsto o En Ejecución, este Frente no puede Finalizarse',
    'shipments.contratoAreaUtil.buscarSubcontrato': 'Buscar subcontrato vigente…',
    'shipments.contratoAreaUtil.nenhumSubcontrato': 'Ningún subcontrato vigente encontrado',
    'shipments.contratoAreaUtil.subcontratoAtualizado': 'Subcontrato de la carga actualizado. Cliente y ruta pasan a venir de él.',
    'shipments.contratoAreaUtil.subcontratoBaixado': 'Este subcontrato fue cancelado o cerrado en el ERP después de ser elegido. La carga sigue ligada a él; el selector ya no lo ofrece.',
    'shipments.contratoAreaUtil.subcontratoPendente': 'Frente aún sin subcontrato asignado',
    'shipments.contratoAreaUtil.buscarCavalo': 'Buscar tractor…',
    'shipments.contratoAreaUtil.buscarCarreta': 'Buscar remolque…',
    'shipments.contratoAreaUtil.cavaloObrigatorio': 'Para quitar el tractor de la carga, usa Quitar conductor. Dejarla con remolque y sin quien lo arrastre no es un estado válido.',
    'shipments.contratoAreaUtil.composicaoTrocada': 'Composición cambiada solo en esta carga. El registro del conjunto no cambió.',
    'shipments.contratoAreaUtil.conjuntoAlterado': 'Conjunto alterado en esta carga',
    'shipments.contratoAreaUtil.conjuntoAlteradoDica': 'Motorista, tractor o remolque fueron cambiados después de la programación, y esta carga ya no coincide con un conjunto registrado. La marca desaparece sola cuando la línea vuelve a un conjunto registrado o la gestión de flota ajusta el registro.',
    'shipments.contratoAreaUtil.servico': 'Servicio',
    'shipments.contratoAreaUtil.pedagio': 'Peaje',
    'shipments.contratoAreaUtil.frente': 'Frente',
    'shipments.contratoAreaUtil.hectares': 'Hectáreas',
    'shipments.contratoAreaUtil.contratoJuridico': 'Contrato jurídico',
    'shipments.contratoAreaUtil.mapas': 'Google Maps',
    'shipments.contratoAreaUtil.mapaPivo': 'Pivote',
    'shipments.contratoAreaUtil.mapaApoio': 'Punto de Apoyo',
    'shipments.contratoAreaUtil.mapaDestino': 'Destino',
    'shipments.contratoAreaUtil.mapaSemCoordenada': 'Sin coordenada registrada',
    'shipments.contratoAreaUtil.safra': 'Zafra',
    'shipments.contratoAreaUtil.informacaoComplementar': 'Información complementaria',
    'shipments.contratoAreaUtil.valorDoErp': 'ERP',
    'shipments.contratoAreaUtil.valorDoCadastro': 'Registro',
    'shipments.contratoAreaUtil.cargasEscaladasSolicitadas': 'Cargas escaladas / solicitadas',
    'shipments.contratoAreaUtil.pctEscaladas': '% Escaladas',
    'shipments.contratoAreaUtil.sinoLabel': 'Anomalías del frente',
    'shipments.contratoAreaUtil.sinoAnomalias': '{{count}} anomalías entre el registro y el ERP. Haz clic para ver.',
    'shipments.contratoAreaUtil.sinoSemAnomalias': 'Registro y ERP coinciden',
    'shipments.contratoAreaUtil.sinoTitulo': 'Registro y ERP difieren',
    'shipments.contratoAreaUtil.anomaliaFrente.pedagio': 'Peaje distinto del ERP',
    'shipments.contratoAreaUtil.anomaliaFrente.km': 'KM distinto del ERP',
    'shipments.contratoAreaUtil.anomaliaFrente.hectares': 'Hectáreas distintas del ERP',
    'shipments.contratoAreaUtil.cargas': 'Cargas',
    'shipments.contratoAreaUtil.adicionarCarga': 'Añadir carga',
    'shipments.contratoAreaUtil.retry': 'Intentar de nuevo',
    'shipments.contratoAreaUtil.nenhumaCarga': 'Ninguna carga para este contrato.',
    'shipments.contratoAreaUtil.definaDataCarga': 'Defina la fecha de la carga antes de elegir el conductor.',
    'shipments.contratoAreaUtil.observacoesObrigatorio': 'Observaciones es obligatorio mientras la alerta de observación esté activa. Resuelve la alerta para limpiar.',
    'shipments.contratoAreaUtil.viagemEncerradaStatus': 'Un viaje cerrado no acepta cambios de estado.',
    'shipments.contratoAreaUtil.tripStatusToast': 'Estado del viaje: {{status}}.',
    'shipments.contratoAreaUtil.viagemConcluidaAtendido': 'Viaje concluido como Atendido.',
    'shipments.contratoAreaUtil.viagemNaoAtendido': 'Viaje cerrado como No atendido. El conjunto volvió a Disponible en el Panel de descarga.',
    'shipments.contratoAreaUtil.reabrirViagem': 'Reabrir viaje',
    'shipments.contratoAreaUtil.reabrirViagemTitle': 'Reabrir el viaje {{number}}',
    'shipments.contratoAreaUtil.reabrirMessage': 'El viaje está cerrado como {{status}}. Reabrirlo lo devuelve al estado en que estaba cuando se cerró, reactiva el monitoreo y queda registrado en el historial con el motivo.',
    'shipments.contratoAreaUtil.reabrirWarning': 'Describe el motivo de la reapertura.',
    'shipments.contratoAreaUtil.reabrir': 'Reabrir',
    'shipments.contratoAreaUtil.viagemReaberta': 'Viaje reabierto en {{status}}.',
    'shipments.contratoAreaUtil.semEtapa': 'sin etapa',
    'shipments.contratoAreaUtil.alertaAtivado': 'Alerta de observación activada.',
    'shipments.contratoAreaUtil.alertaResolvido': 'Alerta de observación resuelta.',
    'shipments.contratoAreaUtil.cargaExcluida': 'Carga {{number}} eliminada.',
    'shipments.contratoAreaUtil.motoristaRemovido': 'Conductor eliminado. Volvió a Disponible en el Panel de descarga.',
    'shipments.contratoAreaUtil.excluirCargaTitle': '¿Eliminar carga?',
    'shipments.contratoAreaUtil.excluirCargaMessage': 'La carga {{number}} será eliminada. Esta acción no se puede deshacer.',
    'shipments.contratoAreaUtil.removerMotoristaTitle': '¿Quitar conductor de la carga?',
    'shipments.contratoAreaUtil.unassignMessage': '{{driver}} volverá a Disponible en el Panel de descarga y podrá ser programado en otra carga.',
    'shipments.contratoAreaUtil.theDriver': 'El conductor',
    'shipments.contratoAreaUtil.remove': 'Quitar',
    'shipments.contratoAreaUtil.motoristaComprometido': 'Conductor ya comprometido',
    'shipments.contratoAreaUtil.escalarMesmoAssim': 'Programar de todos modos',
    'shipments.contratoAreaUtil.warnBase': 'El conductor {{name}} ya está {{status}}',
    'shipments.contratoAreaUtil.warnFrente': 'en el frente {{frente}}',
    'shipments.contratoAreaUtil.warnDia': 'el día {{dia}}',
    'shipments.contratoAreaUtil.warnAsk': '¿Programar de todos modos?',
    'shipments.contratoAreaUtil.unavailable': 'no disponible',
    'shipments.contratoAreaUtil.concluirViagemAtendido': 'Concluir viaje como Atendido',
    'shipments.contratoAreaUtil.avancarPara': 'Avanzar a {{status}}',
    'shipments.contratoAreaUtil.atendidoMessage': 'El viaje {{number}} será marcado como Atendido y el monitoreo automático finalizará. El conjunto permanece Descargando en el Panel de descarga hasta que lo marques como Disponible.',
    'shipments.contratoAreaUtil.atendidoWarning': 'El paso actual no es Descargando. Describe la justificación para concluir fuera de orden.',
    'shipments.contratoAreaUtil.tripWarning': 'El paso está fuera del orden secuencial. Describe la justificación para avanzar.',
    'shipments.contratoAreaUtil.concluir': 'Concluir',
    'shipments.contratoAreaUtil.avancar': 'Avanzar',
    'shipments.contratoAreaUtil.colStatusViagemHub': 'Estado viaje HUB',
    'shipments.contratoAreaUtil.colFilialViagem': 'Sucursal / Viaje',
    'shipments.contratoAreaUtil.colStatusVp': 'Estado VP',
    'shipments.contratoAreaUtil.colStatusNf': 'Estado NF',
    'shipments.contratoAreaUtil.editarConjunto': 'Conductor, placa y remolque',
    'shipments.contratoAreaUtil.semMotorista': 'Sin conductor',
    'shipments.contratoAreaUtil.outraTransportadora': 'Otra transportadora',
    'shipments.contratoAreaUtil.anomaliasLabel': 'Anomalías',
    'shipments.contratoAreaUtil.anomalias': '{{count}} anomalías en el viaje. Haz clic para ver.',
    'shipments.contratoAreaUtil.semAnomalias': 'Sin anomalías en el viaje',
    'shipments.contratoAreaUtil.anomaliasTitulo': 'Anomalías de la carga {{number}}',
    'shipments.contratoAreaUtil.anomalia.conjunto_motorista': 'Conductor distinto del viaje de Protheus',
    'shipments.contratoAreaUtil.anomalia.conjunto_cavalo': 'Tractor distinto del viaje de Protheus',
    'shipments.contratoAreaUtil.anomalia.conjunto_carreta': 'Remolque distinto del viaje de Protheus',
    'shipments.contratoAreaUtil.anomaliaHub': 'En el HUB',
    'shipments.contratoAreaUtil.anomaliaErp': 'En Protheus',
    'shipments.contratoAreaUtil.vincularFrenteErp': 'Vincular frente del ERP',
    'shipments.contratoAreaUtil.equipararViagens': 'Equiparar viajes',
    'shipments.contratoAreaUtil.equipararSemFrente': 'Vincula el frente del ERP antes de equiparar los viajes.',
  },
}
